// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3nh82","inner":"Form_inner__1bh8f","range":"Form_range__iiPKb","name":"Form_name__-62v0","actions":"Form_actions__2hmS7"};